<template>
    <ul class="ath-list-el">
        <ListItem v-for="item in items" :key="item.uid" :item="item" @onClick="onItemClicked" />
    </ul>
</template>
<script>
import GlobalPopoverMixin from '../../globals/GlobalPopoverMixin.js';
import ListItem from './ListItem.vue';

export default {
    name: 'mead-list',
    mixins: [GlobalPopoverMixin],
    props: {
        /**
         * Array of items to render, each passed to a ListItem. Each item is
         * expected to carry at least a uid used as its render key.
         */
        items: {type: Array, default: () => []}
    },
    components: {
        ListItem
    },
    methods: {
        onItemClicked: function () {
            this.closePopover();
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../../../../sass/variables';
.ath-list-el {
    background: var(--c-panel-bg);
    max-width: 40rem;
}
</style>
